import { render } from "./CurriculumComponent.vue?vue&type=template&id=c80113a8&scoped=true&ts=true"
import script from "./CurriculumComponent.vue?vue&type=script&lang=ts"
export * from "./CurriculumComponent.vue?vue&type=script&lang=ts"

import "./CurriculumComponent.vue?vue&type=style&index=0&id=c80113a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80113a8"]])

export default __exports__